<template>
    <q-dialog v-model="is_visible" persistent>
        <q-card>
            <q-card-section>
                <div class="text-h6">{{title}}</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                {{message}}
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat label="OK" color="primary" @click="callback" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>

// import commonLib from "@/libs/commonLib";
// import {mapFields} from "vuex-map-fields";
// import {mapActions} from "vuex";

export default {
    name: "QQDialogError",
    props: {
        is_visible: {
            required: true,
            type: Boolean,
        },
        title: {
            required: true,
            type: String,
        },
        message: {
            required: true,
            type: String,
        },
        callback: {
            default: () => {},
            type: Function,
        },
    },
    data() {
        return {
        }
    },
    computed: {

        // isVisible: function() {
        //     return this.is_visible;
        // }

    },
    methods: {
    }
}

</script>
